import { render, staticRenderFns } from "./BuyerTickets.vue?vue&type=template&id=52976800&"
import script from "./BuyerTickets.vue?vue&type=script&lang=js&"
export * from "./BuyerTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports